import { PatientPayersActions } from 'src/redux/actions/constant';

const {
  UPDATE_PATIENT_PAYER_REQUEST,
  UPDATE_PATIENT_PAYER_SUCCESS,
  UPDATE_PATIENT_PAYER_FAILURE,
  UPDATE_PATIENT_PAYER_RESET,
} = PatientPayersActions;

const initialState: object = {
  response: null,
  loading: false,
  isSuccess: false,
};

export const updatePatientPayerReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_PATIENT_PAYER_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: true,
      };
    }

    case UPDATE_PATIENT_PAYER_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };

    case UPDATE_PATIENT_PAYER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_PATIENT_PAYER_RESET:
      return initialState;

    default:
      return state;
  }
};
